import { GetOperations, Operation } from '@occc-app/offerHelpers/types';
import { makeEarningMechanismCreateOperation } from '@occc-app/offerHelpers/operations/earningMechanism';
import { OfferFragment } from '@occc/graphql';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';

import { ConfigureFormValues } from '../../../types';
import { createEarningMechanismCreateInput } from '../../../utils';

export const getEarningMechanismOperations: GetOperations = (
  _awardId: string,
  award: OfferFragment | undefined,
  values: ConfigureFormValues,
) => {
  if (!award) {
    return [];
  }

  const operations: Operation[] = [];
  const earningMechanismId = award.earningMechanism?.id;
  const createInput = createEarningMechanismCreateInput(award.id, values);

  if (earningMechanismId) {
    operations.push(makeDeleteOperation('earningMechanismDelete', earningMechanismId));
  }

  if (createInput?.configuration) {
    operations.push(
      makeEarningMechanismCreateOperation(createInput.offerId, createInput.configuration),
    );
  }

  return operations;
};
